import {
  RegulationRequestTypeDto,
  WorkflowType,
} from "../../common/service/server/dto/RegulationRequestTypeDto";

/**
 * Determines if a request type should skip email verification
 * Used for opt-out and limit request types that don't require email verification
 */
export const isSkipHiddenType = (requestType: RegulationRequestTypeDto): boolean => {
  return (
    requestType.workflowType === WorkflowType.OPT_OUT ||
    requestType.workflowType === WorkflowType.LIMIT ||
    requestType.workflowType === WorkflowType.PROFILING_OPT_OUT
  );
};

/**
 * Determines if a request type requires email verification
 * Used for withdrawal requests that mandate email verification
 */
export const isEmailVerificationRequired = (requestType: RegulationRequestTypeDto): boolean => {
  return (
    requestType.workflowType === WorkflowType.WITHDRAW_CONSENT ||
    requestType.workflowType === WorkflowType.PIPEDA_WITHDRAW_CONSENT
  );
};
